import LiquidChart from "./liquid-chart";
import "./totalCompliance.css";

const TotalCompliance = ({ score, org = 0 }) => {
  //container with title for the liquid gauge
  return (
    <div className="liquid-chart-container">
      <h4 className="component-title mt-2">Total Compliance</h4>
      {/* <h6
        className="component-subtitle"
        style={{ visibility: !org ? "hidden" : "visible" }}
      >
        {org}
      </h6> */}
      <div style={{ paddingTop: "1.5rem" }}>
        <LiquidChart score={score} />
      </div>
    </div>
  );
};

export default TotalCompliance;
